import axios from "axios";
import config from "@assets/config.json"; // api 请求json
import api from "../../api";
//获取产品信息

const state = {
  list: [],
  _current: {
    name: "",
    mail: "",
    city: "",
    gender: "",
    interest: [],
    date: "",
    time: "",
    desc: "",
    ExhibitIntroductType: "0",
  },
  pageInfo: {
    pageSize: 10,
    pageIndex: 1,
    totalCount: 1,
  },
  wheres: {},
};

const mutations = {
  refushList(state, { pageSize, pageIndex, totalCount, totalPages, items }) {
    state.list = items;

    state.pageInfo = {
      pageSize: pageSize,
      pageIndex: pageIndex,
      totalCount: totalCount,
      totalPages: totalPages,
    };
  },
  refushCurrent(state, data) {
    //console.error('refushCurrent', data)
    state._current = data;
  },
  refushPageInfo(state, data) {
    state.pageInfo = {
      ...state.pageInfo,
      ...data,
    };
  },
  refushWheres(state, data) {
    state.wheres = {
      ...data,
    };
  },
};

const getters = {
  list: state => {
    let list = [];
    if (state.list && state.list.length > 0) {
      list = JSON.parse(JSON.stringify(state.list));
      for (let item of list) {
        item.banner = JSON.parse(item.banner);
      }
    }
    return list;
  },
  current: state => {
    let doc = JSON.parse(JSON.stringify(state._current));
    if (state._current && state._current.banner) {
      doc.banner = JSON.parse(doc.banner);
    }
    if (state._current.styleId !== null && state._current.styleId !== undefined) {
      doc.styleId = doc.styleId.toString();
    }
    if (state._current.styleId && state._current.styleId.toString() == "1") {
      doc.introduction = JSON.parse(doc.introduction);
    }
    if (doc.video) {
      doc.video = JSON.parse(doc.video);
    }
    //console.error('doc-----',doc)
    return doc;
  },
  pageInfo(state) {
    return state.pageInfo;
  },
};

const actions = {
  async getList({ commit, state }, { data = { CompId: "24ba3ba3-a0b4-42ba-9e91-ce032da13e3d" }, params = null }) {
    //console.error('getList---------')
    let list = await api.product.GetByCompId({
      data: {
        ...data,
        ...state.pageInfo,
        wheres: state.wheres,
      },
      params: params,
    });
    commit("refushList", list);
  },
  async getOne({ commit }, { data = { id: "9f45f8cd-767c-4386-841d-e7d1e7264e3c" } }) {
    let doc = await api.product.GetOne({
      data: data,
    });
    commit("refushCurrent", doc);
  },
  async add({ commit }, { data = {} }) {
    //console.error('add-----')
    let re = api.product.Add({
      data: data,
    });
    commit("refushCurrent", {});
    return re;
  },
  async edit({ commit }, { data = {} }) {
    //console.error('edit----',data)
    let re = await api.product.Edit({
      data: data,
    });
    commit("refushCurrent", {});
    return re;
  },
  async remove({ commit }, { data = {} }) {
    let re = await api.product.Remove({
      data: data,
    });
    commit("refushCurrent", {});
    return re;
  },

  getProductByAgentId({ rootState }, opt) {
    // 获取全部产品信息
    return new Promise((resolve, reject) => {
      axios
        .post(`${config.api.reqApi}/api/product/GetByAgent`, opt, rootState.header)
        .then(data => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch(err => {
          console.log(err.response.data);
        });
    });
  },
  getAllByChannelId({ rootState }, opt) {
    // 主办后台获取全部产品信息
    return new Promise((resolve, reject) => {
      axios
        .post(`${config.api.reqApi}/api/Product/GetAllByChannelId?LiveChannelId=${opt.channelId}&api-version=1.0`, opt.option, rootState.header)
        .then(data => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch(err => {
          console.log(err.response.data);
        });
    });
  },
  getHostProductByExId({ rootState }, opt) {
    // 主办后台获取全部产品信息
    return new Promise((resolve, reject) => {
      axios
        .post(`${config.api.reqApi}/api/product/GetBackEndByExhibition`, opt, rootState.header)
        .then(data => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch(err => {
          console.log(err.response.data);
        });
    });
  },
  getProduct({ rootState }, opt) {
    // 获取全部产品信息
    return new Promise((resolve, reject) => {
      axios
        .post(`${config.api.reqApi}/api/product/GetAllByCompId`, opt, rootState.header)
        .then(data => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch(err => {
          console.log(err.response.data);
        });
    });
  },
  getProductLog({ rootState }, opt) {
    // 获取全部产品信息记录
    return new Promise((resolve, reject) => {
      axios
        .post(`${config.api.reqApi}/api/ProductViewLog/GetByProId2`, opt, rootState.header)
        .then(data => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch(err => {
          console.log(err.response.data);
        });
    });
  },
  postProductTagCountTou({ rootState }, opt) {
    // 投票产品查询公司所有浏览量
    return new Promise((resolve, reject) => {
      axios
        .post(`${config.api.reqApi}/api/ProductTagCount/GetAllByCompId`, opt, rootState.header)
        .then(data => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch(err => {
          console.log(err.response.data);
        });
    });
  },
  postGetViewLogByProductTou({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${config.api.reqApi}/api/ProductTagCount/GetViewLogByProduct`, opt, rootState.header)
        .then(data => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch(err => {
          console.log(err.response.data);
        });
    });
  },

  postExcelExportProductView({ rootState }, opt) { // 浏览量 导出 
    return new Promise((resolve, reject) => {
      axios.post(`${config.api.reqApi}/api/Product/excelExportProductView`, opt,{
        'responseType':'blob'
        }, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  postExcelGetAllByCompIdTou({ rootState }, opt) { // 投票产品 导出 
    return new Promise((resolve, reject) => {
      axios.post(`${config.api.reqApi}/api/ProductTagCount/excelGetAllByCompId`, opt,{
        'responseType':'blob'
        }, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },

  getProductById({ rootState }, id) {
    // 根据id查询对应产品
    return new Promise((resolve, reject) => {
      axios
        .get(`${config.api.reqApi}/api/product/?id=${id}`, rootState.header)
        .then(data => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch(err => {
          console.log(err.response.data);
        });
    });
  },
  getExAreaList({ rootState }, opt) {
    // 根据公司Id和展会Id获取展区列表
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${config.api.reqApi}/api/product/GetExAreaList?compid=${opt.compid}&ExhibitionId=${opt.ExhibitionId}`,
          rootState.header
        )
        .then(data => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch(err => {
          console.log(err.response && err.response.data);
        });
    });
  },
  setProductShow({ rootState }, opt) {
    //修改产品屏蔽、显示
    return new Promise((resolve, reject) => {
      axios
        .put(`${config.api.reqApi}/api/product/SetShow`, opt, rootState.header)
        .then(data => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch(err => {
          console.log(err.response.data);
        });
    });
  },
  addProduct({ rootState }, opt) {
    // 添加产品信息
    return new Promise((resolve, reject) => {
      axios
        .post(`${config.api.reqApi}/api/Product`, opt, rootState.header)
        .then(data => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch(err => {
          console.log(err.response.data);
        });
    });
  },
  delProduct({ rootState }, id) {
    // 删除产品信息
    return new Promise((resolve, reject) => {
      axios
        .delete(`${config.api.reqApi}/api/Product?id=${id}`, rootState.header)
        .then(data => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch(err => {
          console.log(err.response.data);
        });
    });
  },
  editProduct({ rootState }, opt) {
    // 修改产品信息
    return new Promise((resolve, reject) => {
      axios
        .put(`${config.api.reqApi}/api/Product`, opt, rootState.header)
        .then(data => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch(err => {
          console.log(err.response.data);
        });
    });
  },
  // 产品分组
  getProductGroupById({ rootState }, id) {
    // 根据id查询对应产品
    return new Promise((resolve, reject) => {
      axios
        .get(`${config.api.reqApi}/api/productGroup/?id=${id}`, rootState.header)
        .then(data => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch(err => {
          console.log(err.response.data);
        });
    });
  },
  getProductGroup({ rootState }, opt) {
    // 根据id查询对应产品
    return new Promise((resolve, reject) => {
      axios
        .post(`${config.api.reqApi}/api/productGroup/GetByCompId`, opt, rootState.header)
        .then(data => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch(err => {
          console.log(err.response.data);
        });
    });
  },
  addProductGroup({ rootState }, opt) {
    // 添加产品分组信息
    return new Promise((resolve, reject) => {
      axios
        .post(`${config.api.reqApi}/api/productGroup`, opt, rootState.header)
        .then(data => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch(err => {
          console.log(err.response.data);
        });
    });
  },
  delProductGroup({ rootState }, id) {
    // 删除产品分组信息
    return new Promise((resolve, reject) => {
      axios
        .delete(`${config.api.reqApi}/api/productGroup?id=${id}`, rootState.header)
        .then(data => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch(err => {
          console.log(err.response.data);
        });
    });
  },
  editProductGroup({ rootState }, opt) {
    // 修改产品分组信息
    return new Promise((resolve, reject) => {
      axios
        .put(`${config.api.reqApi}/api/productGroup`, opt, rootState.header)
        .then(data => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch(err => {
          console.log(err.response.data);
        });
    });
  },
  getProductByGroupId({ rootState }, opt) {
    // 根据产品分组id获取产品
    return new Promise((resolve, reject) => {
      axios
        .post(`${config.api.reqApi}/api/product/GetPagedListByGroupId`, opt, rootState.header)
        .then(data => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch(err => {
          console.log(err.response.data);
        });
    });
  },
  // getProductByGroupId({ }, opt) { // 根据产品分组id获取产品
  //     return new Promise((resolve, reject) => {
  //         fly.post(`/api/product/GetPagedListByGroupId`,opt, rootState.header).then(data => {
  //             if (data.status === 200 && data.data) {
  //                 if (data.data) {
  //                     resolve(data.data);
  //                 };
  //             }
  //         });
  //     });
  // }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
